<template>
  <!-- 头部整体盒子 -->
  <div
    id="header"
    class="container-fuild"
  >
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <a href="#">
        <div class="header-nav-logo">
          <img src="@/assets/img/logo.png">
        </div>
      </a>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="item.name"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span
              v-if="item.children.length>0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <!-- <dl v-if="item.children.length>0">
            <dt
              v-for="(i,n) in item.children"
              :key="n"
            >
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl> -->
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <a href="#">
          <img
            class="center-block"
            src="@/assets/img/logo.png"
            alt="logo"
          >
        </a>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <span class="span-name">{{menuName}}</span>
        <span
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <!-- 下拉按钮 -->
          <span :class="menuClass"></span>
        </span>
        <!-- 导航内容 -->
        <ul
          id="menu"
          class="header-nav-m-wrapper collapse"
        >
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <!-- 下拉内容的文字 -->
            <router-link
              :to="item.path"
              style="width: 100%;height: 40px;"
            >
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "Header",
  data() {
    return {
      config: config,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "Tessai资管后台系统",
        //       path: "/software/smartTown",
        //     },
        //     {
        //       name: "Tessai客户端系统",
        //       path: "/software/bigData",
        //     },
        //   ],
        // },
        {
          name: "证书及荣誉",
          path: "/service",
          children: [],
        },
        {
          name: "主营业务",
          path: "/companyintroduction",
          children: [],
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: [],
        },
        {
          name: "人才招聘",
          path: "/jobchance",
          children: [],
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
      ],
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(3, 55, 133, 0.8);
  /* background: url("../assets/img/header.png") no-repeat; */
  /* background: rgba(#134e99, 0.5); */
  background-size: cover;
  transition: all ease 0.6s;
  height: 100px;
  position: fixed;
  width: 100%;
  z-index: 999;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  /* background: #474747; */
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 100px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 95px; */
  height: 100%;
  /* height: 45px; */
  position: absolute;
  left: 0;
  top: 0;
  /* top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto; */
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 100px;
  float: right;
  margin-right: 10% !important;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #fff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #fff;
  text-decoration: none;
  border-bottom: 2px solid #fff;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 768px) {
  .visible-xs {
    display: flex !important;
    /* background: rgba(3, 55, 133, 0.8) !important; */
  }
  #header {
    height: 50px;
  }
  #header .header-nav-m {
    /* position: relative; */
    display: flex;
    justify-content: space-between;
  }
  #header .header-nav-m span {
    font-size: 14px !important;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    flex: 0 0 130px;
    height: 50px;
    position: relative;
    text-align: left;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    flex: 1;
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    /* background: #124e99; */
    /* background: #ff0 !important; */
    /* background: rgba(3, 55, 133, 0.5) !important; */
    /* position: relative; */
  }
}
@media screen and (max-width: 960px) {
  #header .header-nav .header-nav-wrapper {
    /* line-height: 100px;
  float: right; */
    margin-right: 0 !important;
    /* margin: 0;
  max-width: 800px; */
  }
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    font-size: 12px !important;
    font-weight: normal !important;
  }
}
@media screen and (max-width: 997px) {
  /* #header{
    height: 50px;
  } */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    display: inline-block;
    width: 100vw;
    height: 40px;
  }
  #header .header-nav-m {
    /* position: relative; */
    /* display: flex; */
    justify-content: space-between;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    /* flex: 1; */
    height: 50px;
    /* position: relative; */
    text-align: left;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    /* flex: 1; */
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #124e99;
    /* position: relative; */
  }
  #header .header-nav-m .header-nav-m-menu > .span-name {
    position: absolute;
    right: 64px;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    right: 16px;
    /* position: absolute; */
    /* top: 50%; */
    /* right: 20px; */
    /* margin-top: -20px; */
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    box-shadow: 0 5px 10px -5px #ccc;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f6f6f6;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    /* color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative; */
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue